/**
 * Material-UI styles for the Footer component.
 *
 * @module components/common/Footer
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Returns a Material-UI styles object for the Footer component.
 *
 * @param {Object} theme - The Material-UI theme object.
 * @returns {Object} A styles object keyed by class name.
 */
export const Footer = (theme) => ({
    root: {
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(3),
        display: 'flex',
        bottom: 0,
    },
    copyright: {
        flexGrow: 1,
        textAlign: 'center',
    },
    elements: {
        marginRight: theme.spacing(2),
    },
});

export default Footer;
